import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { SidebarContainer, Icon, SidebarWrapp, SidebarMenu, SidebarLink, SidebarCtaWrap, SidebarHeader, SubNav, SubItem } from './SidebarStyles';
import { ArrowDown, CloseIcon } from "src/styles/DesignSystem";

import logo from 'src/assets/logo.png';
const Sidebar = ({ isOpen, toggle, page}) => {

    const [subIsOpen, setSub] = useState(false);

    const toogleSub = () => {setSub(!subIsOpen)};

    return (
        <SidebarContainer isOpen={isOpen} >

            <SidebarHeader>
                <Link to="/" onClick={toggle}>   
                    <img src={logo} alt="Hipermercado das Rações" />
                </Link>

                <Icon onClick={toggle}>
                    <CloseIcon />
                </Icon>
            </SidebarHeader>
            
            <SidebarWrapp>
                <SidebarMenu>
                    
                    <li>
                        <SidebarLink to="/" onClick={toggle} >Home</SidebarLink>
                    </li>

                    <li>
                        <SidebarLink to="/institucional" onClick={toggle} >Institucional</SidebarLink>
                    </li>

                    <li>
                        <SidebarLink to="#" onClick={toogleSub} >Serviços</SidebarLink>
                        <SubNav className={subIsOpen ? 'active' : ''}>
                            <SubItem>
                                <SidebarLink to="/servicos/servico">Clínica veterinaria</SidebarLink>
                            </SubItem>

                            <SubItem>
                                <SidebarLink to="/servicos/servico">Banho e tosa</SidebarLink>
                            </SubItem>

                            <SubItem>
                                <SidebarLink to="/servicos/servico">Loja</SidebarLink>
                            </SubItem>
                        </SubNav>
                    </li>

                    <li>
                        <SidebarLink to="/contato" onClick={toggle}>Contato</SidebarLink>
                    </li>
                </SidebarMenu>
                
            </SidebarWrapp>
        </SidebarContainer>
    )
}

export default Sidebar;